export const ru = {
    ak_sync_error: 'Не успели синхронизировать ваш профиль у нашего поставщика, пожалуйста, обратитесь в {supportChatLink}',
};
